import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  text: {
    fill: '#ffffff',
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontWeight: 700,
    fontSize: 34,
    letterSpacing: 1,
  },
  accent: {
    fill: '#5ec8d8',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 40"
    >
      <text x="0" y="30" className={classes.text}>
        SC<tspan className={classes.accent}>GROUPS</tspan>
      </text>
    </svg>
  );
};
